import styles from "./styles.module.scss";

export default function SkeletonGrid({
    count,
    className,
}: {
    count: number;
    className?: string;
}) {
    return (
        <div className={className ?? styles.loadingGrid}>
            {Array.from({ length: count }).map((_, i) => (
                <div key={i} className={styles.skeletonCard}>
                    <div className={styles.skeletonImage} />
                    <div className={styles.skeletonBody}>
                        {/* Title - matches .cardTitle */}
                        <div className={styles.skeletonTitle} />
                        {/* Meta row - matches .cardMeta with margin: 16px 0 */}
                        <div className={styles.skeletonMeta} />
                        {/* Excerpt lines - matches .cardExcerpt */}
                        <div className={styles.skeletonExcerpt} />
                        <div className={styles.skeletonExcerpt} />
                    </div>
                </div>
            ))}
        </div>
    );
}
